import React from 'react';

function AuthButton({ title, ...otherprops }) {
  return (
    <button className="login__btn btn btn_orange btn_wide" {...otherprops}>
      {title}
    </button>
  );
}

export default AuthButton;
